/**
 * An view containing common properties
 */
var ToolbarView = /** @class */ (function () {
    function ToolbarView() {
    }
    return ToolbarView;
}());
export { ToolbarView };
//# sourceMappingURL=toolbar-view.js.map